import * as types from 'constants/ActionTypes';

/* eslint-disable import/prefer-default-export */
// enable eslint if/when more action creators are added to the file
export function togglePurchaseReviewOverlay(visible) {
  return { type: types.TOGGLE_PURCHASE_REVIEW_OVERLAY, visible };
}
